import type { ReactElement, ReactNode } from 'react';
import { describeError } from '../api/apiError.js';

export type AlertTone = 'error' | 'warning' | 'info' | 'success';

export function Alert({
  tone = 'info',
  children,
}: {
  tone?: AlertTone;
  children: ReactNode;
}): ReactElement {
  return (
    <div className={`alert alert--${tone}`} role={tone === 'error' ? 'alert' : 'status'}>
      <span>{children}</span>
    </div>
  );
}

/** Renders nothing when there is no error, so callers need no conditional. */
export function ErrorAlert({ error }: { error: unknown }): ReactElement | null {
  if (error === null || error === undefined) {
    return null;
  }
  return <Alert tone="error">{describeError(error)}</Alert>;
}
